import { createAction } from 'redux-actions';

export const onBoardingAction = createAction('REQUEST/POST_ONBOARDING');
export const onBoardingSignUpAction = createAction('REQUEST/POST_ONBOARDING_SIGN_UP');
export const onBoardingWizardAction = createAction('REQUEST/POST_ONBOARDING_WIZARD');
export const markWizardFinishedAction = createAction('REQUEST/MARK_WIZARD_FINISHED');
export const sendPreApprovalQuoteAction = createAction('REQUEST/SEND_PRE_APPROVAL_QUOTE');
export const sentPreApprovalDocumentAction = createAction('REQUEST/SEND_PRE_APPROVAL_DOCUMENT');
